import Socket from '@/socket'
import OpenAISocketHandler from '@/utils/open-ai/OpenAISocketHandler'

export default {
  initSocket() {
    Socket.getSocket().on('presentation: doc_to_quiz_generation_done', (doc) => {
      OpenAISocketHandler.handleDocToSlideGenerationDoneWhenGlobalImport(doc)
    })
    Socket.getSocket().on('presentation:chat:response', (socketData) => {
      OpenAISocketHandler.handleChatResponse(socketData)
    })
  },

  disconnectSocket(editor) {
    Socket.getSocket().off('presentation: doc_to_quiz_generation_done')
    Socket.getSocket().off(`global--user-${editor.$store.state.currentUser.id}`)
    Socket.getSocket().off(`export-${editor.$store.state.currentUser.id}`)
  },
}
